import { ENV_CHAIN_ID } from 'config/constants'
import addresses from 'config/constants/contracts'

export const getCakeAddress = () => {
  return addresses.ceto[ENV_CHAIN_ID]
}
export const getMasterChefAddress = () => {
  return addresses.masterChef[ENV_CHAIN_ID]
}
export const getMulticallAddress = () => {
  return addresses.mulltiCall[ENV_CHAIN_ID]
}
export const getWbnbAddress = () => {
  return addresses.weth[ENV_CHAIN_ID]
}
export const getZapperAddress = () => {
  return addresses.zapper[ENV_CHAIN_ID]
}
export const getCetoBurnAddress = () => {
  return addresses.cetoBurn[ENV_CHAIN_ID]
}

export const getBcetoAddress = () => {
  return addresses.bceto[ENV_CHAIN_ID]
}
